import { MdManageHistory } from "@onemind-services-llc/react-icons-ng/md";
import { GoShield } from "@onemind-services-llc/react-icons-ng/go";
import { FaRegHandshake } from "@onemind-services-llc/react-icons-ng/fa";
import { SimpleList } from "@/components/list";

export const FEATURES_CONSTANTS = [
  {
    icon: MdManageHistory,
    title: " Managed Services",
    subTitle: "Ideal for teams that want to stay focused on innovation.",
    content: (
      <SimpleList
        points={[
          "Turnkey experience",
          "24/7 monitoring & support",
          "Zero infrastructure overhead",
        ]}
      />
    ),
  },
  {
    icon: GoShield,
    title: "Unmanaged Services",
    subTitle: "Built for teams with strong in-house expertise.",
    content: (
      <SimpleList
        points={[
          "Full administrative control",
          "Developer autonomy",
          "No vendor lock-in",
        ]}
      />
    ),
  },
  {
    icon: FaRegHandshake,
    title: "Co-Managed Services",
    subTitle: "A collaborative approach for shared responsibility.",
    content: (
      <SimpleList
        points={[
          "Flexible division of tasks",
          "Access to OneMind’s cloud experts",
          "Ideal for growing or transitioning teams",
        ]}
      />
    ),
  },
];
